/* Supernaturals */
jQuery(window).on('load', function(){
  jQuery('.products-banner-section-row-advanced').find('.main-products-image').slick('slickGoTo', 0);
});

function init() {
  if(jQuery(window).width() < 640){
    setTimeout(function(){
         jQuery('.expert-item').addClass('loadimage');
    },3000);
  }
  if(jQuery(window).width() < 480){
     setTimeout(function(){
         jQuery('.newsletters-form-section').addClass('loadimage');
    },3500);
  }
}
window.onload = init;

function check_if_in_view_OneWay() {
	var lazy_elements = jQuery('.lazy-background,.lazy-image');
  	var benefits = jQuery('.benefit-item');
  var sticky_mobile = jQuery('#shopify-section-supernaturals-product-list');
	var window_height = jQuery(window).height();
	var window_top_position = jQuery(window).scrollTop();
	var halfscreen =  (window_height / 2);
  if(jQuery(window).width() < 768 ){
   var top_extra = 10; 
  }
  else{    
   var top_extra = 300; 
  }
	var window_bottom_position = window_top_position + window_height + top_extra;

	jQuery.each(lazy_elements, function() {
		var element = jQuery(this);
		var element_height = element.outerHeight();
		var element_top_position = element.offset().top;
		var element_bottom_position = (element_top_position + element_height);
		if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
          
          if(element.hasClass('lazy-image')){
            
            var img = element.attr('data-src');
            element.attr('src',img);
            
    		sameHeightColumns('.img-txt-inner-container');
            
          }else{
            
            var bg = element.attr('data-bg');
            element.css('background-image','url('+bg+')');
            
          }
			
		}
	});
  
    jQuery.each(benefits, function() {
      
        var element = jQuery(this);
        var element_height = element.outerHeight();
        var element_top_position = element.offset().top;
        var window_bottom_position = window_top_position + halfscreen;
        var element_bottom_position = (element_top_position + element_height);
      
        var window_W = jQuery(window).width();
  
        if(window_W > 640){
         element_top_position = element_top_position - 400;
        }else{
          element_top_position = element_top_position - 300;
        }

        if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {

          element.addClass('visible');

        }else{

          element.removeClass('visible');

        }
      
    });
  
  if(jQuery('#shopify-section-supernaturals-product-list').length){
    
    var sticky_mobile = jQuery('#shopify-section-supernaturals-product-list');
    var sticky_mobile_height = sticky_mobile.outerHeight();
    var window_scroll = window_top_position + 100 ;
    if(window_scroll > sticky_mobile_height){ 
      jQuery('body').addClass('sticky--active');
    }
    else{      
      jQuery('body').removeClass('sticky--active');
    }
  }
  
  
  if(jQuery('.benefits-content-list').length){
  
    var load_height = jQuery('.benefits-content-list').outerHeight();
  	var load_top = jQuery('.benefits-content-list').offset().top;
  
  	var visible_point = window_top_position + window_height;
  	var visible_element_height = visible_point - load_top;
  
  
  	jQuery('.benefits-loading-item').css('height',((visible_element_height - 150) * 100 / load_height)+'%');
  	//jQuery('.benefits-loading-item').height(visible_element_height - halfscreen + 60);
  
  }
  

}

/* AVA-445 */
function snsamewidth(elementclass){
    jQuery(elementclass).css('width', 'auto');
    let el_width = 0;
    jQuery(elementclass).each(function(){
        if (jQuery(this).outerWidth() > el_width) {
            el_width = jQuery(this).outerWidth();
        }
    });
    jQuery(elementclass).outerWidth(el_width);
}
/* END AVA-445 */

//Make elements with same class the same height
function sameheight(elementclass){
	jQuery(elementclass).css('height','auto');
	el_height = 0;
	jQuery(elementclass).each(function(){
		if(jQuery(this).outerHeight() > el_height){
			el_height = jQuery(this).outerHeight();
		}
	});
	jQuery(elementclass).outerHeight(el_height);
}

function squareElement(el){
	jQuery(el).each(function(){
		var $width = jQuery(this).width();
		jQuery(this).outerHeight($width);
	});
}

//same column height
function sameHeightColumns(elementclass){
	jQuery(elementclass).each(function(){
		
		jQuery(this).children().css('height','auto');
		el_height = 0;
		
		jQuery(this).children().each(function(){
			
			if(jQuery(this).outerHeight() > el_height){
				el_height = jQuery(this).outerHeight();
			}
			
		});
		
		jQuery(this).children().outerHeight(el_height);
		
	});
}

//Add parent class
function parentClass() {
    jQuery('.add_row_class').each(function() {
        jQuery(this).parents('.vc_row').last().addClass(jQuery(this).attr('row_class'));
    });
}


//function to check if id is valid
function isCssIdValid (id) {
    re = /^#[A-Za-z0-9]+[\w\-\:\.]*$/
    return re.test(id)
}


function addItemToCart(variant_id, qty, selling_plan, product_id,varint_name, move_to_checkout = false ) {
  data = {items: [{
    "id": variant_id,
    "quantity": qty,
    "selling_plan": selling_plan
  }]}
  jQuery('.rd-container .product-tab-item.active').addClass('adding');
  jQuery('.rd-container .product-tab-item.active .loading-button').fadeIn();
  
  const custom_gift_product = document.querySelector('.product-tab__footer--active .product-tabs__gifts-block input[name="gift-product-option"]:checked')?.value
    || jQuery('.button-atc-product[product_id="'+variant_id+'"]').attr('gift_product')
    || jQuery('.button-atc-product[product_id="'+variant_id+'"]').parents('.product-tab-item').attr('gift_product')
    || jQuery('.button-atc-product[extra_product_id="'+variant_id+'"]').parents('.product-tab-item').attr('gift_product');
  if(custom_gift_product){
    data.items.push({
      "id": custom_gift_product,
      "quantity": 1,
      "selling_plan": "",
      "properties": {
        _gift_product:"true"
      }
    });
    
    fetch('/cart.js')
      .then(function(response) {
        return response.json(); 
      })
      .then(async (cart) => {
        if (cart.items.length > 0) {
          const line_items_to_remove = {};
          cart.items
            .filter((line_item) => {
              return !!line_item.properties?._gift_product;
            })
            .forEach((line_item) => {
              line_items_to_remove[line_item.variant_id] = 0;
            });
          
          if (Object.keys(line_items_to_remove).length > 0) {
            await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({updates:line_items_to_remove})
            })
          }
        }
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function(result) {
              //window.location.href = '/cart';
              fetch('/cart.js', { credentials: 'same-origin' })
                .then(function(response) {
                  return response.json(); 
                })
                .then(function(cart) {
                  if(move_to_checkout) {
                    window.location = '/checkout'
                  }
                  else{
                    jQuery('.site-header__cart-count').removeClass('hide');
                    if(cart.item_count < 10){
                      cart.item_count = '0' + cart.item_count;
                    }
                    jQuery('.rd-cart-items-bubble').html(cart.item_count);
                    jQuery('.rd-cart-items-bubble').removeClass('hide');

                    /* AVA-509 */
                    /* 
                    ** This code replaces the window.location.href = '/cart/checkout' code above. 
                    ** To go back to the checkout redirect after add to cart, comment the code below and delete the double slash comments above.
                    */
                    /* trigger drawer edit */
                    fetch(`${routes.cart_url}?sections=cart-drawer`)
                    .then((response) => response.json())
                    .then((sections) => {
                      const sectionIds = ['cart-drawer'];
                      for (const sectionId of sectionIds) {
                        const htmlString = sections[sectionId];
                        const html = new DOMParser().parseFromString(htmlString, 'text/html');
                        const sourceElement = html.querySelector(`${sectionId} .drawer__inner`);
                        const targetElement = document.querySelector(`${sectionId} .drawer__inner`);
                        if (targetElement && sourceElement) {
                          targetElement.replaceWith(sourceElement);
                        }
                      }
                      document.body.classList.add('overflow-hidden');
                      const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                      if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
                      theme_cart.classList.add('active');
                    })
                    .catch((e) => {
                      console.error('Error updating cart sections:', e);
                    });
                    /* END trigger drawer edit */
                    /* END AVA-509 */
                  
                    setTimeout(function(){
                        jQuery('.rd-container .product-tab-item.active').addClass('added');
                        jQuery('.rd-container .product-tab-item.active').removeClass('adding');
                      	jQuery('.rd-container .product-tab-item.active .loading-button').fadeOut();

                        jQuery('.rd-container .product-tab-item.active .adding').hide();
                        jQuery('.rd-container .product-tab-item.active .added').fadeIn();

                    }, 500);
                  
                    setTimeout(function(){

                      jQuery('.rd-container .product-tab-item.active').removeClass('added');

                      jQuery('.rd-container .product-tab-item.active .adding').fadeIn();
                      jQuery('.rd-container .product-tab-item.active .added').hide();

                      ga('ec:addProduct', {
                        'id': product_id,
                        'name': 'Supernaturals Superme',
                        'brand': 'Supernaturals',
                        'variant': varint_name,
                      });
                    

                    }, 3000);
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
            }
          });
      })

  }
  else {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(result) {
      //window.location.href = '/cart';
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(response) {
          return response.json(); 
        })
        .then(function(cart) {
          if(move_to_checkout) {
            
            window.location = '/checkout'
          }
          else{
            jQuery('.site-header__cart-count').removeClass('hide');
            if(cart.item_count < 10){
              cart.item_count = '0' + cart.item_count;
            }
            jQuery('.rd-cart-items-bubble').html(cart.item_count);
            jQuery('.rd-cart-items-bubble').removeClass('hide');

            /* AVA-509 */
            /* 
            ** This code replaces the window.location.href = '/cart/checkout' code above. 
            ** To go back to the checkout redirect after add to cart, comment the code below and delete the double slash comments above.
            */
            /* trigger drawer edit */
            fetch(`${routes.cart_url}?sections=cart-drawer`)
            .then((response) => response.json())
            .then((sections) => {
              const sectionIds = ['cart-drawer'];
              for (const sectionId of sectionIds) {
                const htmlString = sections[sectionId];
                const html = new DOMParser().parseFromString(htmlString, 'text/html');
                const sourceElement = html.querySelector(`${sectionId} .drawer__inner`);
                const targetElement = document.querySelector(`${sectionId} .drawer__inner`);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
              document.body.classList.add('overflow-hidden');
              const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
              theme_cart.classList.add('active');
            })
            .catch((e) => {
              console.error('Error updating cart sections:', e);
            });
            /* END trigger drawer edit */
            /* END AVA-509 */
          
            setTimeout(function(){
                jQuery('.rd-container .product-tab-item.active').addClass('added');
                jQuery('.rd-container .product-tab-item.active').removeClass('adding');
              	jQuery('.rd-container .product-tab-item.active .loading-button').fadeOut();

                jQuery('.rd-container .product-tab-item.active .adding').hide();
                jQuery('.rd-container .product-tab-item.active .added').fadeIn();

            }, 500);
          
            setTimeout(function(){

              jQuery('.rd-container .product-tab-item.active').removeClass('added');

              jQuery('.rd-container .product-tab-item.active .adding').fadeIn();
              jQuery('.rd-container .product-tab-item.active .added').hide();

              ga('ec:addProduct', {
                'id': product_id,
                'name': 'Supernaturals Superme',
                'brand': 'Supernaturals',
                'variant': varint_name,
              });


            }, 3000);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  });
  // window.location = '/checkout';
  }

}


function isOnScreen(elem) {
	if( elem.length == 0 ) {
		return;
	}
	
	var site_header = jQuery('#shopify-section-header').outerHeight();
	
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height - ($window.height() / 2);
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height
	
	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

function check_if_in_view_OneWay11() {
	var lazy_elements = jQuery('.comm-video');
	var window_height = jQuery(window).height();
	var window_top_position = jQuery(window).scrollTop();
  var ww = jQuery(window).width();
	
	var window_bottom_position = window_top_position + window_height + 50;

	jQuery.each(lazy_elements, function() {
		var element = jQuery(this);
		var element_height = element.outerHeight();
		var element_top_position = element.offset().top;
		var element_bottom_position = (element_top_position + element_height);
    if(element.find('.slick-current .video--url').hasClass('onplay')){
      if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
        jQuery('.slick-current .video--url video').trigger('play');
      }else{
        jQuery('.slick-current .video--url video').trigger('pause');
      }
    }
    else{
      console.log('else')
    }
		
	});
}


/*********************************/
/* Supernaturals redesign BEGIN */
/*******************************/
jQuery(document).ready(function(){

  check_if_in_view_OneWay11();
  jQuery(window).scroll(function() {
      check_if_in_view_OneWay11();
  });

  /* AVA-445 */
  if(jQuery('.rd-stats-section .rd-stat-icon .number--box .number--number').length){
    snsamewidth('.rd-stats-section .rd-stat-icon .number--box .number--number');
  }

  sameheight('.reputon-single-review .reputon-review-info .reputon-name');

  setTimeout(function(){
    sameheight('.reputon-single-review .reputon-review-info .reputon-name');
  }, 1500);
  /* END AVA-445 */
  
  jQuery('.rd-community-image.lazy-background.video--url').on('click',function(){
    if(jQuery(this).hasClass('onplay')){
      jQuery(this).removeClass('onplay');
      jQuery(this).find('video').trigger('pause');
    }
    else{
      jQuery(this).addClass('onplay');
      jQuery(this).find('video').trigger('play');

      jQuery(this).find('video').prop('muted', false);
      jQuery(this).parents('.video_url_wrap').find('span').removeClass('muted');
    }   
  });

  jQuery('.video_url_wrap span').on('click',function(){
    if(jQuery(this).hasClass('muted')){
      jQuery(this).parents('.video_url_wrap').find('video').prop('muted', false);
      jQuery(this).removeClass('muted');
    }
    else{
      jQuery(this).parents('.video_url_wrap').find('video').prop('muted', true);
      jQuery(this).addClass('muted');
    }
  });

  jQuery('.comm-video video').on('ended',function(){
    jQuery('.comm-video .rd-community-list').slick("slickNext");
  });

  
  jQuery('.comm-video .rd-community-list').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if(currentSlide != nextSlide){
      setTimeout(function(){
        jQuery('.video--url video').trigger('pause');
        jQuery('.slick-slide .video--url').removeClass('onplay');
        jQuery('.slick-current .video--url video').trigger('play');
        jQuery('.slick-slide.slick-current .video--url').addClass('onplay');
      },1000);
    }
    
  });	

  jQuery('.comm-video video').on('play',function(){
    jQuery('.video--url video').not(this).trigger('pause');
  });
  
  sameheight('.same--height');
  sameheight('.nutri-showcase-item-desc');
  sameheight('.rd-expert-quote');
  sameheight('.rd-homemap-top > div');
  sameheight('.comm-video .rd-community-text');

  setTimeout(function(){
    sameheight('.rd-expert-quote');
  },4000);

  if(jQuery('.rd-site-header').hasClass('trans-bg')){
    jQuery('#PageContainer').addClass('trans-pad');
    jQuery('.main-content > div').addClass('trans-div');
  }

  jQuery('.each-nutri-row').each(function(){
    var eachline = jQuery(this).find('div');
    sameheight(eachline);
	});

  scroll_sound = document.getElementById("scroll--sound"); 
  console.log(scroll_sound);

  jQuery(window).scroll(function() {
      check_animation();
      check_animation2();
     
      /*var ww = jQuery( window ).width();
      if(ww < 1023){
        check_animation2();
        check_animation();
      }*/
  });

});

function check_animation() {
	var scrolling_ingredient = jQuery('.scrolling--ingredient');
  var parent_animation = jQuery('.scrolling--ingredients');
  var mobile_animation = jQuery('.full--ingredients');
  
	var window_height = jQuery(window).height();
	var window_top_position = jQuery(window).scrollTop();
	var window_bottom_position = window_top_position + window_height;
  var ww = jQuery( window ).width();
	//Animations

	jQuery.each(scrolling_ingredient, function() {
		var element = jQuery(this);
		var element_height = element.outerHeight();	

		var element_top_position = element.offset().top;
		var element_bottom_position = (element_top_position + element_height);

    
    if(ww < 1023){
      element_top_position = element_top_position + 300;
      element_bottom_position = element_bottom_position + 300;
    }
    else{
    }

		if((element_top_position <= window_bottom_position) && (element_bottom_position >= window_top_position + window_height) && !element.hasClass('start')) {
        jQuery('.static--ingredients .each--ingredient').removeClass('active');
        jQuery('.static--ingredients .each--ingredient').eq(element.index()).addClass('active');
        scrolling_ingredient.removeClass('start');
        element.addClass('start');
        var activeing = element.attr("for-block");
        jQuery('.ing-showcase-item').removeClass("active--ing");
        jQuery('.ing-showcase-item[to-block="'+ activeing +'"]').addClass("active--ing");
        //console.log(element.index());
        //element.removeClass('sticky--bottom');
        scroll_sound.play();    
            
		}
        else{
        }
        
	});

  if(ww < 1023){
   
  jQuery.each(mobile_animation, function() {
		var element = jQuery(this);
		var element_height = element.outerHeight();	

		var element_top_position = element.offset().top + 300;
		var element_bottom_position = (element_top_position + element_height) + 300;

		if((element_top_position <= window_bottom_position) && (element_bottom_position >= window_top_position + window_height)) {
      jQuery('.static--ingredients').addClass('scrolling--mobile');
            
		}
      else{
        jQuery('.static--ingredients').removeClass('scrolling--mobile');
      }
        
	});

  }
    
    //Animations
	jQuery.each(parent_animation, function() {
		var element = jQuery(this);
		var element_height = element.outerHeight();	

		var element_top_position = element.offset().top;
		var element_bottom_position = (element_top_position + element_height);
    var test = window_top_position + window_height;

    if(ww < 1023){
      element_bottom_position = element_bottom_position + 300;
    }
    else{
    }
    

		if((element_bottom_position >= window_top_position + window_height ) && (element_top_position <= window_bottom_position - window_height )) {
        //console.log('ifififififif');
			  element.addClass('starting--scroll');
        element.removeClass('sticky--bottom--parent');
        jQuery('.new--mob--price.mobile--sticky--price').addClass('another--stick2');

		}
    else if(element_bottom_position <= window_top_position + window_height){
      //console.log('elseifelseif');
      element.addClass('sticky--bottom--parent');
      element.removeClass('starting--scroll');
      jQuery('.new--mob--price.mobile--sticky--price').removeClass('another--stick2');
    }
    else{
        //console.log('elselseelse');
        element.removeClass('starting--scroll sticky--bottom--parent');
        jQuery('.new--mob--price.mobile--sticky--price').removeClass('another--stick2');
    }
	});

}


function check_animation2() {
	var scrolling_ingredient = jQuery('.each-nutri-row');
  var parent_animation = jQuery('.nutri-list-and-content-new');
  var mobile_animation = jQuery('.each-nutri-table-bott');
  
	var window_height = jQuery(window).height();
	var window_top_position = jQuery(window).scrollTop();
	var window_bottom_position = window_top_position + window_height;
  var ww = jQuery( window ).width();
	//Animations

	/*jQuery.each(scrolling_ingredient, function() {
		var element = jQuery(this);
		var element_height = element.outerHeight();	

		var element_top_position = element.offset().top;
		var element_bottom_position = (element_top_position + element_height);

    element_top_position = element_top_position + 150;
    element_bottom_position = element_bottom_position + 150;

		if((element_top_position <= window_bottom_position) && (element_bottom_position >= window_top_position + window_height) && !element.hasClass('start')) {
        jQuery('.each-nutri-row').removeClass('active--row');
        jQuery('.each-nutri-row').eq(element.index()).addClass('active--row');
        //scrolling_ingredient.removeClass('start');
        //element.addClass('start');
        var activeing = element.attr("row-id");
        jQuery('.nutri-showcase-item').removeClass("active--show");
        jQuery('.nutri-showcase-item[case-id="'+ activeing +'"]').addClass("active--show");
        //console.log(element.index());
        //element.removeClass('sticky--bottom');            
		}
    else{
    }
	});*/
    
    //Animations
	jQuery.each(parent_animation, function() {
		var element = jQuery(this);
		var element_height = element.outerHeight();	

		var element_top_position = element.offset().top;
		var element_bottom_position = (element_top_position + element_height);
    var test = window_top_position + window_height;   

    element_top_position = element_top_position + 450;
    //console.log(element_bottom_position + ' ' + window_top_position + ' ' + window_height + ' ' + element_top_position + ' ' + window_bottom_position + ' ' + window_height);

		if((element_top_position <= window_bottom_position ) && (element_bottom_position >= window_top_position + window_height)) {
      //console.log('ifififififif');
			  element.addClass('starting--scroll');
        element.removeClass('sticky--bottom--parent');    
        jQuery('.new--mob--price.mobile--sticky--price').addClass('another--stick');

		}
    else if(element_bottom_position <= window_top_position + window_height){
      //console.log('elseifelseif');
      element.addClass('sticky--bottom--parent');
      element.removeClass('starting--scroll');
      jQuery('.new--mob--price.mobile--sticky--price').removeClass('another--stick');
    }
    else{
      //console.log('elselseelse');
        element.removeClass('starting--scroll sticky--bottom--parent');
        jQuery('.new--mob--price.mobile--sticky--price').removeClass('another--stick');
    }
	});

}

function sectionpadding() {
  var secth = jQuery('.nutri-showcase-item.active--show').outerHeight() - 6;
  jQuery('.each-nutri-table-bott').css('padding-bottom', secth );
}

function mappadding() {
  var ww = jQuery( window ).width();
  var cc = jQuery( '.rd-container' ).width();
  var widthw = (ww - cc) / 2;
  jQuery('.rd-homemap-body .slick-list.draggable').css('padding-right', widthw);
  jQuery('.rd-homemap-body .slick-next.slick-arrow').css('right', widthw - 110);
}

jQuery(document).ready(function(){

  jQuery(".menu-item.mega-menu-item").on({mouseenter:function(){
    jQuery(".main-site__header-inner").addClass("active_submenu");
    jQuery(this).addClass("active_submenu_this");
  }});

  jQuery(".menu-item.mega-menu-item").on({mouseleave:function(){
    jQuery(this).removeClass("active_submenu_this");
  }});

  jQuery(".main-site__header-inner").on({mouseleave:function(){
    jQuery(this).removeClass("active_submenu");
    jQuery(".menu-item.mega-menu-item").removeClass("active_submenu_this");
  }});
  

  mappadding();

  var ww = jQuery( window ).width();

  jQuery('.scroll--top').on('click',function(e) {
    e.preventDefault();
    jQuery('html, body').animate({
      scrollTop: 0
    }, 1000);
  });

  sameheight('.nutri-showcase-item');
  sameheight('.ing-showcase-item-desc');
  sameheight('.rd-eachmap-text > div');

  
  if(ww > 1023){
      
      jQuery('.each-nutri-table-bott .each-nutri-row').on('mouseover',function() {
        var activerow = jQuery(this).attr("row-id");
        jQuery('.each-nutri-table-bott .each-nutri-row').removeClass("active--row");
        jQuery('.nutri-showcase-item').removeClass("active--show");
  
        jQuery('.nutri-showcase-item[case-id="'+ activerow +'"]').addClass("active--show");
        jQuery(this).addClass("active--row");
      });
  
  }
  else {
      
      jQuery('.each-nutri-table-bott .each-nutri-row').on('click',function() {
        var activerow = jQuery(this).attr("row-id");
        jQuery('.each-nutri-table-bott .each-nutri-row').removeClass("active--row");
        jQuery('.nutri-showcase-item').removeClass("active--show");
  
        jQuery('.nutri-showcase-item[case-id="'+ activerow +'"]').addClass("active--show");
        jQuery(this).addClass("active--row");

        setTimeout(function(){
          sectionpadding();
        },200);
        
      });
     
  }
  
  jQuery('body').on('click','.new--each--tab',function(){
    $current_el = jQuery(this).parents('.product-info-section');
    $current_el.find('.new--each--tab').removeClass('tab-head-active');
    jQuery(this).addClass('tab-head-active');

    if(jQuery(this).hasClass('einz')){
     
      var tab2 = jQuery(this).attr('tab');
       console.log(tab2);
      $current_el.find('.product-description').removeClass('show-desc');
      $current_el.find('.product-description[tab="' + tab2 + '"]').addClass('show-desc');
      $current_el.find('.add-top-cart-product-container').removeClass('show--price');
      $current_el.find('.add-top-cart-product-container[tab="' + tab2 + '"]').addClass('show--price');  
      $current_el.find('.new--tab--products').addClass('tab-einz');
    }
    else{
      var tab2 = jQuery(this).attr('tab');
      $current_el.find('.product-description').removeClass('show-desc');
      $current_el.find('.add-top-cart-product-container').removeClass('show--price');
      $current_el.find('.new--prod--title').removeClass('tab-name-active');
      $current_el.find('.new--tab--products').removeClass('tab-einz');
      $current_el.find('.product-description[tab="' + tab2 + '"]').addClass('show-desc');
      $current_el.find('.add-top-cart-product-container[tab="' + tab2 + '"]').addClass('show--price');
      $current_el.find('.new--prod--title[tab="' + tab2 + '"]').addClass('tab-name-active');
    }

    if(jQuery(this).parents('.new--prod--style').hasClass('new--prod--addon')){
        jQuery('.new--prod--style.new--prod--addon').find('.main-products-image').slick('slickGoTo', 0);
    }
    
  });

  if(window.location.hash) {
    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
    if(hash == 'showaddon'){
      jQuery('.new--addon').show();
    }
  } 

  jQuery('body').on('click','.new--prod--title',function(){
    $current_el = jQuery(this).parents('.product-info-section');

    $current_el.find('.new--prod--title').removeClass('tab-name-active');
    jQuery(this).addClass('tab-name-active');
    var tab1 = jQuery(this).attr('tab');
    $current_el.find('.product-description').removeClass('show-desc');
    $current_el.find('.product-description[tab="' + tab1 + '"]').addClass('show-desc');
    $current_el.find('.add-top-cart-product-container').removeClass('show--price');
    $current_el.find('.add-top-cart-product-container[tab="' + tab1 + '"]').addClass('show--price');  

   
    if(jQuery(this).parents('.new--prod--style').hasClass('new--prod--addon')){
      var innerhtml = jQuery(this).html();
      if (innerhtml.indexOf("90") >= 0){
          jQuery('.new--prod--style.new--prod--addon').find('.main-products-image').slick('slickGoTo', 1);
      }
      else{
          jQuery('.new--prod--style.new--prod--addon').find('.main-products-image').slick('slickGoTo', 0);

      }
    }
  });

  jQuery('body').on('click', '.product-list-tabs__tab-item', function() {
    var tabValue = jQuery(this).attr('tab');
    var $section = jQuery(this).closest('.product-list-tabs');
    
    $section.find('.product-list-tabs__tab-item').removeClass('product-list-tabs__tab-item--active');
    jQuery(this).addClass('product-list-tabs__tab-item--active');

    $section.find('.product-tab__footer').removeClass('product-tab__footer--active');
    $section.find('.product-tab__footer[tab="' + tabValue + '"]').addClass('product-tab__footer--active');
});

  $('.logo-showcase-list').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    centerMode: true,
    rows: 0,
    arrows: false,
    autoplay: true,
    pauseOnHover: false,
  	autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1580,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 640,
        settings: {
          centerMode: true,
          slidesToShow: 3,
        }
      }
    ]
  });

  $('.logo-showcase-list--new').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    centerMode: true,
    rows: 0,
    arrows: false,
    autoplay: true,
    pauseOnHover: false,
  	autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1580,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });

  $('.rd-experts-list').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    rows: 0,
    arrows: true,
    autoplay: true,
    pauseOnHover: false,
  	autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.rd-homemap-list').slick({
    dots: false,
    infinite: false,
    speed: 600,
    slidesToShow: 1,
    rows: 0,
    arrows: true,
    autoplay: false,
    pauseOnHover: false,
    asNavFor: '.rd-homemap-map-inner'
  });

  $('.rd-homemap-map-inner').slick({
    dots: false,
    infinite: false,
    speed: 600,
    slidesToShow: 1,
    rows: 0,
    arrows: false,
    autoplay: false,
    pauseOnHover: false,
    asNavFor: '.rd-homemap-list'
  });

  $('.rd-sustainability-list').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    rows: 0,
    arrows: true,
    autoplay: true,
    pauseOnHover: false,
  	autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.rd-community-list.instagram-comm').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    rows: 0,
    arrows: true,
    autoplay: true,
    pauseOnHover: false,
  	autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.comm-video .rd-community-list').slick({
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 5,
    slidesToScroll: 1,
    rows: 0,
    arrows: true,
    //autoplay: true,
    pauseOnHover: false,
  	//autoplaySpeed: 3500,
    focusOnSelect: true,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.rd-blog-posts-list').slick({
    dots: false,
    infinite: false,
    speed: 600,
    slidesToShow: 3,
    rows: 0,
    arrows: true,
    autoplay: true,
    pauseOnHover: false,
  	autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  
  $('.new--prod--style').each(function(){
    if($(this).hasClass('new--prod--addon')){
      var autoplay_vr = false;
    }
    else{
      var autoplay_vr = true;
    }
      jQuery(this).find('.main-products-image').slick({
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        arrows: false,
        autoplay: autoplay_vr,
        pauseOnHover: false,
        autoplaySpeed: 3500
      });
  });

  sameheight('.rd-blog-post-text');
  sameheight('.rd-community-text');
  sameheight('.new--prod--style .main-products-image .product-single--media');
  sameheight('.ing-showcase-item-desc');

  jQuery('.rd-newsletters-form-section #email_signup').on('submit',function(event){
    jQuery('.klaviyo_messages .error_message').html('').fadeOut();
    if ( jQuery('#k_id_acceptance').is(':checked') ){
      jQuery('.rd-newsletters-form-section #email_signup').trigger('submit');
    }else{
      event.preventDefault();
      jQuery('.klaviyo_messages .error_message').html('Please accept the Terms and Conditions.').fadeIn();
    }
})

});

document.addEventListener("shopify:section:load", function(event){

    $section = jQuery('#shopify-section-' + event.detail.sectionId);

    $section.find('.logo-showcase-list').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      centerMode: true,
      rows: 0,
      arrows: false,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 3500,
      responsive: [
        {
          breakpoint: 640,
          settings: {
            centerMode: true,
          }
        }
      ]
    });

    $section.find('.rd-experts-list').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 2,
      rows: 0,
      arrows: true,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 3500,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });

    $section.find('.rd-homemap-list').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      rows: 0,
      arrows: true,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 3500,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
    $section.find('.rd-sustainability-list').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      rows: 0,
      arrows: true,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 3500,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
    $section.find('.rd-community-list.instagram-comm').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 2,
      rows: 0,
      arrows: true,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 3500,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
    $section.find('.rd-blog-posts-list').slick({
      dots: false,
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      rows: 0,
      arrows: true,
      autoplay: true,
      pauseOnHover: false,
      autoplaySpeed: 3500,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

});

jQuery(window).on('resize',function(){

  sameheight('.same--height');
  sameheight('.nutri-showcase-item');
  sameheight('.rd-eachmap-text > div');
  sameheight('.comm-video .rd-community-text');

  $('.rd-blog-posts-list').slick('resize');

  var ww = jQuery( window ).width();
  if(ww < 1023){
    sectionpadding();
  }

  /* AVA-445 */
  sameheight('.reputon-single-review .reputon-review-info .reputon-name');
  /* AVA-445 */
  
});


jQuery(window).on('resize load',function(){
  sameheight('.rd-blog-post-text');
  sameheight('.rd-community-text');
  sameheight('.new--prod--style .main-products-image .product-single--media');
  sameheight('.same--height');
  sameheight('.nutri-showcase-item');
  sameheight('.ing-showcase-item-desc');
  sameheight('.nutri-showcase-item-desc');
  sameheight('.rd-homemap-top > div');
  sameheight('.rd-eachmap-text > div');
  sameheight('.comm-video .rd-community-text');

  mappadding();

  var ww = jQuery( window ).width();
  if(ww < 1023){
    sectionpadding();
  }
});
/*******************************/
/* Supernaturals redesign END */
/*****************************/

jQuery(document).ready(function(){
  
  /*jQuery('.rd-promise-item').each(function(){
    sameheight(jQuery('.same--height2');
	});*/
  
  sameheight('.blog-post-text');
  sameheight('.benefits-text-content-column, .benefits-main-image');
  //check_if_in_view_OneWay();
  jQuery(window).scroll(function() {
    sameheight('.blog-post-text');
    check_if_in_view_OneWay();
  });
  
  sameHeightColumns('.img-txt-inner-container');
  setTimeout(function(){
    sameheight('.benefits-text-content-column, .benefits-main-image');
  	sameHeightColumns('.img-txt-inner-container');
  },500);
  
  jQuery(window).scroll(function(){
    if (jQuery(window).scrollTop() >= 70) { jQuery('#shopify-section-header').addClass('fixed'); }
    else {jQuery('#shopify-section-header').removeClass('fixed');}

    if (jQuery(window).scrollTop() >= 1270) { jQuery('.mobile--sticky--price').addClass('fixed'); }
    else {jQuery('.mobile--sticky--price').removeClass('fixed');}
  });
  
  $(".experts-content-list").on("init", function(event, slick){
    $(this).find(".slick-dots").addClass('nr_slides_'+slick.slideCount);
  });
  
  $('.experts-content-list').slick({
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: true,
  	autoplaySpeed: 3500
  });
  
  $(".ingredients-carousel").on("init", function(event, slick){
    $(".ingredients-carousel .slick-dots").addClass('nr_slides_'+slick.slideCount);
  });
  
  $('.ingredients-carousel').slick({
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    pauseOnHover: false,
    adaptiveHeight: true,
    autoplay: true,
  	autoplaySpeed: 3500
  });
  
  setTimeout(function(){
    if(jQuery(".scrolling-section").length){
      jQuery(".scrolling-section").stick_in_parent({
        offset_top : jQuery('#shopify-section-header').outerHeight() - 20,
        parent : '.benefits-main-image',
      });
    }
  },500);
  
    setTimeout(function(){
    if(jQuery(".scrolling-section-icons").length){
      
      var window_W = jQuery(window).width();
      
      if(window_W < 375){
        var extra_w = 15;
        
      }else if(window_W < 768){
        var extra_w = 10;
      }else{
        var extra_w = 50;
      }
      
      jQuery(".scrolling-section-icons").stick_in_parent({
        offset_top : jQuery('#shopify-section-header').outerHeight() - extra_w,
        parent : '.faq-page-template',
      });
    }
  },500);
  
  
  jQuery('body').on('click','.faq-item-title',function(){
    
    if(jQuery(this).parents('.faq-item').hasClass('open')){
      
      jQuery(this).parents('.faq-item').removeClass('open');
      
    }else{
      
      jQuery('.faq-item-title').not(this).parents('.faq-item').removeClass('open');
      jQuery(this).parents('.faq-item').addClass('open');
    }
    
  });
  
  jQuery('body').on('click','.load-more-nutrition-boxes',function(){
    jQuery('.nutrition-item').fadeIn();
    jQuery(this).fadeOut();
    check_if_in_view_OneWay();
  });
  
  jQuery('body').on('click','.button-atc-product.button',function(){
    
    if(jQuery(this).parents('.product-tab-item').hasClass('adding') || jQuery(this).parents('.product-tab-item').hasClass('added')){
    }else{
      
      var product_id = document.querySelector(`#${this.getAttribute('data-variant-picker')} input[type="radio"]:checked`)?.getAttribute('data-variant-id') || jQuery(this).attr('product_id');
      var qty = jQuery(this).attr('qty');
      var selling_plan = jQuery(this).attr('selling_plan');
      var variant_name = jQuery('.product-tab-item.active .top-tab-item h3').html();
      const move_to_checkout = jQuery(this).attr('data-move-to-checkout') == 'true';
      const clear_before_adding = jQuery(this).attr('data-clear-before-adding') == 'true';
      if(clear_before_adding){
        fetch('/cart/clear.js').then(()=>{
          addItemToCart(product_id, qty, selling_plan, product_id, variant_name,move_to_checkout)
        })
      }
      else{
        addItemToCart(product_id, qty, selling_plan, product_id, variant_name,move_to_checkout)
      }
    }
    
  });
  
  jQuery('body').on('click','.product-tab-button',function(){
    
  	jQuery('.product-tab-button, .product-tab-item , .shop-page-template .product-info-image').removeClass('active');
    
    jQuery(this).addClass('active');
    
    var tabname = jQuery(this).attr('tab');
    
    
    jQuery(this).parents('.sn-products-section').find('.image-tab-'+tabname).addClass('active');
    //jQuery('image-tab-'+tabname).addClass('active');
    
    var index = jQuery(this).index();
	jQuery('.product-tab-item').eq(index).addClass('active');
	jQuery('.mobile--price').find('.product-tab-item').eq(index).addClass('active');
    
  });
  
  /* scroll on reviews section */
  jQuery('body').on('click','.review--placeholder .spr-badge',function(e){
       	e.preventDefault();
       if(jQuery('.shopify-shop-product-reviews').length){
          jQuery('html, body').animate({
           	scrollTop: jQuery('.shopify-shop-product-reviews').offset().top - jQuery('#shopify-section-header').outerHeight()
         }, 1000);
       }
      
     });
    
  
  
  /* Load more */
  jQuery('.js-load-more').on('click', function(){
    
    var $this = jQuery(this);
    $this.find('.lds-ring').fadeIn();
    var totalPages = parseInt(jQuery('.data-total-pages').val());
    var currentPage = parseInt(jQuery('.data-current-page').val());
        
    var next_page = currentPage + 1;
    var next_next_page = currentPage + 2;
    var nextUrl = jQuery('.data-next-url').val();
    
    jQuery.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        jQuery('.blog-posts-list').append(jQuery(responseHTML).find('.blog-posts-list').html());
        
        
        jQuery('.data-current-page').val(next_page);
        jQuery('.data-next-url').val('/pages/magazin?page='+next_next_page);
        
      },
      complete: function() {
        
        if(next_next_page > totalPages) {
           $this.addClass('disabled'); 
        }
        
        check_if_in_view_OneWay();
        
        setTimeout(function(){
          $this.find('.lds-ring').fadeOut();
        }, 500);
        
      }
    })
    
     
  });
  
  $(".shopify-section.latest-posts-row .blog-posts-list").on("init", function(event, slick){
    $(".shopify-section.latest-posts-row .slick-dots").addClass('nr_slides_'+slick.slideCount);
  });
  
  $('.shopify-section.latest-posts-row .blog-posts-list').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          dots: true
        }
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true
        }
      }
    ]
  });
  
 
  $(".related-blog-posts .blog-posts-list").on("init", function(event, slick){
    $(".related-blog-posts .slick-dots").addClass('nr_slides_'+slick.slideCount);
  });
  
  $('.related-blog-posts .blog-posts-list').slick({
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  jQuery('.stripes').on('click',function(){
    jQuery(this).toggleClass('activeclose');
    jQuery('body').toggleClass('activeover');
    jQuery('body').toggleClass('activeover-for');
  });

  
    /*
    jQuery('.main-site__header-inner .menu-item > a').on('click',function(e){

      var ww = jQuery( window ).width();
      if(ww < 1023){
        e.preventDefault();
        jQuery(this).toggleClass('activearrow');
        jQuery(this).parent().find('.mega_menu__submenu').toggleClass('activearrowdrop');
      }

    });
    */

    jQuery('.main-site__header-inner .has---img .mega_menu_item_description').on('click',function(e){

      var ww = jQuery( window ).width();
      if(ww < 1023){
        e.preventDefault();
        jQuery(this).parents('.mega_menu_details_container').toggleClass('activearrow');
        jQuery(this).parents('.mega_menu__column').find('.mega_menu_item_submenu').toggleClass('activearrowdrop');
      }

    });
 

  jQuery('body').on('click','.see-all-features',function(){
    jQuery(this).addClass('hidden');
    jQuery('.option-item').fadeIn();
  });
  
  jQuery('body').on('click','#simulate_checkout_action',function(){
  	jQuery('input.cart__submit.btn.btn--small-wide.button').click();
  });
  
  
  //Scroll to media
  
  		jQuery('.faq-icons .option-item .link-wrapper').on('click',function(t) {
          
          var window_W = jQuery(window).width();
      
          if(window_W < 375){
            var extra = 90;
            }else{
              var extra = 80;
            }
          
			var $headerheight = parseInt(jQuery('.rd-site-header-outer').outerHeight()) + extra;
			
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = jQuery(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				
				if (target.length) {
					jQuery('html, body').animate({
						scrollTop: target.offset().top - $headerheight
					}, 1000);
					
					return false;
				}else{

				}
			}
		});
  
  //Scroll Sticky
	 
	 window.addEventListener('scroll', function(e) {
		jQuery('.faq-page-template .faq-section').each(function(){
			if(isOnScreen(jQuery(this))) {
				var current_category = jQuery(this).attr('id');
				jQuery('.faq-page-template .faq-icons .options-content-list-headings .option-item').removeClass('active');
				jQuery('.faq-page-template .faq-icons .options-content-list-headings .option-item[faq-title="#'+current_category+'"]').addClass('active');
			}	
		});
	});
  
  
  jQuery('body').on('click','.product-description ul li.info',function(){
    jQuery(this).toggleClass('open');
  });

  /* AVA-352 */
  $('.rd3-ingredients-carousel').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    rows: 0,
    fade: true,
    autoplay: false,
  });

  jQuery(document).on('click', '.rd3-ingredient-item-container .rd-button', function(e){

    e.preventDefault();
    let href = jQuery(this).attr('href');

    jQuery('.rd3-ingredients-carousel-item .lazy-image').each(function(){
      let data_src = jQuery(this).attr('data-src');
      jQuery(this).attr('src', data_src);
    });

    if(jQuery('.rd3-modal-main-item [item_carousel="'+href+'"]').length){

      let index_item = jQuery('.rd3-modal-main-item [item_carousel="'+href+'"]').index();
      jQuery('.rd3-ingredients-carousel').slick('slickGoTo', index_item);
      jQuery('.rd3-modal-main-item').addClass('active-mod');

    }

  });

  jQuery(document).on('click', '.rd3-modal-close-btn, .rd3-modal-banner', function(e){
    jQuery('.rd3-modal-main-item').removeClass('active-mod');
  });

  jQuery(document).on('click', '.rd3-benefits-item .rd-button', function(e){
    e.preventDefault();
    jQuery(this).parents('.rd3-benefits-item').addClass('active');
  });

  jQuery(document).on('click', '.rd3-benefits-item .rd3-modal-close-btn', function(e){
    e.preventDefault();
    jQuery(this).parents('.rd3-benefits-item').removeClass('active');
  });
  /* END AVA-352 */

  /* AVA-707 */
  if($('.lphg-image-gallery').length){

    $('.lphg-image-gallery').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      rows: 0,
      fade: true,
      autoplay: false,
      asNavFor: '.lphg-image-gallery-thumbs'
    });

    $('.lphg-image-gallery-thumbs').slick({
      arrows: false,
      infinite: true,
      speed: 600,
      rows: 0,
      slidesToShow: 12,
      focusOnSelect: true,
      variableWidth: true,
      asNavFor: '.lphg-image-gallery'
    });

  }
  /* END AVA-707 */

});

jQuery(window).on('resize load',function(){
  /*jQuery('.rd-promise-item').each(function(){
    sameheight('.same--height2');
	});*/
    sameHeightColumns('.img-txt-inner-container');
    sameheight('.benefits-text-content-column, .benefits-main-image');
    sameheight('.blog-post-text');
    sameheight('.rd-expert-quote');
  if(jQuery('body').hasClass('shop-page-template')){}
  else{
  	check_if_in_view_OneWay();
  }

  var ww = jQuery( window ).width();
  if(ww < 1023){
    sectionpadding();
  }
});

/* End of SN js */

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

function removeImageLoadingAnimation(image) {
  // Remove loading animation
  var imageWrapper = image.hasAttribute('data-image-loading-animation')
    ? image
    : image.closest('[data-image-loading-animation]');

  if (imageWrapper) {
    imageWrapper.removeAttribute('data-image-loading-animation');
  }
}

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
(function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)})(function(i){"use strict";var e=window.Slick||{};e=function(){function e(e,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(e),appendDots:i(e),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(e),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(e).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,"undefined"!=typeof document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=t++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}var t=0;return e}(),e.prototype.activateADA=function(){var i=this;i.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):o===!0?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&i.options.adaptiveHeight===!0&&i.options.vertical===!1){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),s.options.rtl===!0&&s.options.vertical===!1&&(e=-e),s.transformsEnabled===!1?s.options.vertical===!1?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):s.cssTransitions===!1?(s.options.rtl===!0&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),s.options.vertical===!1?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),s.options.vertical===!1?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this,o=t.getNavTarget();null!==o&&"object"==typeof o&&o.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};e.options.fade===!1?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,e.options.fade===!1?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(i.options.infinite===!1&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1===0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;e.options.arrows===!0&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),e.options.infinite!==!0&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(o.options.dots===!0&&o.slideCount>o.options.slidesToShow){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),e.options.centerMode!==!0&&e.options.swipeToSlide!==!0||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.options.draggable===!0&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>0){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(r.originalSettings.mobileFirst===!1?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||l===!1||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!==0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t,o=this;if(e=o.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var s in e){if(i<e[s]){i=t;break}t=e[s]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),e.options.accessibility===!0&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),e.options.accessibility===!0&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),e.options.accessibility===!0&&e.$list.off("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>0&&(i=e.$slides.children().children(),i.removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){var e=this;e.shouldClick===!1&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",e.options.fade===!1?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;t.cssTransitions===!1?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;e.cssTransitions===!1?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(t){var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&o.is(":focus")&&(e.focussed=!0,e.autoPlay())},0)}).on("blur.slick","*",function(t){i(this);e.options.pauseOnFocus&&(e.focussed=!1,e.autoPlay())})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){var i=this;return i.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(i.options.infinite===!0)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(i.options.centerMode===!0)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),n.options.infinite===!0?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,n.options.vertical===!0&&n.options.centerMode===!0&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!==0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),n.options.centerMode===!0&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:n.options.centerMode===!0&&n.options.infinite===!0?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:n.options.centerMode===!0&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=n.options.vertical===!1?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,n.options.variableWidth===!0&&(o=n.slideCount<=n.options.slidesToShow||n.options.infinite===!1?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=n.options.rtl===!0?o[0]?(n.$slideTrack.width()-o[0].offsetLeft-o.width())*-1:0:o[0]?o[0].offsetLeft*-1:0,n.options.centerMode===!0&&(o=n.slideCount<=n.options.slidesToShow||n.options.infinite===!1?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=n.options.rtl===!0?o[0]?(n.$slideTrack.width()-o[0].offsetLeft-o.width())*-1:0:o[0]?o[0].offsetLeft*-1:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){var e=this;return e.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(e.options.infinite===!1?i=e.slideCount:(t=e.options.slidesToScroll*-1,o=e.options.slidesToScroll*-1,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o,s,n=this;return s=n.options.centerMode===!0?Math.floor(n.$list.width()/2):0,o=n.swipeLeft*-1+s,n.options.swipeToSlide===!0?(n.$slideTrack.find(".slick-slide").each(function(e,s){var r,l,d;if(r=i(s).outerWidth(),l=s.offsetLeft,n.options.centerMode!==!0&&(l+=r/2),d=l+r,o<d)return t=s,!1}),e=Math.abs(i(t).attr("data-slick-index")-n.currentSlide)||1):n.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){var t=this;t.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),t.options.accessibility===!0&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);if(i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),s!==-1){var n="slick-slide-control"+e.instanceUid+s;i("#"+n).length&&i(this).attr({"aria-describedby":n})}}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.options.focusOnChange?e.$slides.eq(s).attr({tabindex:"0"}):e.$slides.eq(s).removeAttr("tabindex");e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),i.options.accessibility===!0&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;e.options.dots===!0&&e.slideCount>e.options.slidesToShow&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),e.options.accessibility===!0&&e.$dots.on("keydown.slick",e.keyHandler)),e.options.dots===!0&&e.options.pauseOnDotsHover===!0&&e.slideCount>e.options.slidesToShow&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),e.options.accessibility===!0&&e.$list.on("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),i.options.dots===!0&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&e.options.accessibility===!0?e.changeSlide({data:{message:e.options.rtl===!0?"next":"previous"}}):39===i.keyCode&&e.options.accessibility===!0&&e.changeSlide({data:{message:e.options.rtl===!0?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||r.$slider.attr("data-sizes"),n=document.createElement("img");n.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),r.$slider.trigger("lazyLoaded",[r,e,t])})},n.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),r.$slider.trigger("lazyLoadError",[r,e,t])},n.src=t})}var t,o,s,n,r=this;if(r.options.centerMode===!0?r.options.infinite===!0?(s=r.currentSlide+(r.options.slidesToShow/2+1),n=s+r.options.slidesToShow+2):(s=Math.max(0,r.currentSlide-(r.options.slidesToShow/2+1)),n=2+(r.options.slidesToShow/2+1)+r.currentSlide):(s=r.options.infinite?r.options.slidesToShow+r.currentSlide:r.currentSlide,n=Math.ceil(s+r.options.slidesToShow),r.options.fade===!0&&(s>0&&s--,n<=r.slideCount&&n++)),t=r.$slider.find(".slick-slide").slice(s,n),"anticipated"===r.options.lazyLoad)for(var l=s-1,d=n,a=r.$slider.find(".slick-slide"),c=0;c<r.options.slidesToScroll;c++)l<0&&(l=r.slideCount-1),t=t.add(a.eq(l)),t=t.add(a.eq(d)),l--,d++;e(t),r.slideCount<=r.options.slidesToShow?(o=r.$slider.find(".slick-slide"),e(o)):r.currentSlide>=r.slideCount-r.options.slidesToShow?(o=r.$slider.find(".slick-cloned").slice(0,r.options.slidesToShow),e(o)):0===r.currentSlide&&(o=r.$slider.find(".slick-cloned").slice(r.options.slidesToShow*-1),e(o))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){var i=this;i.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;if(!t.unslicked&&(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),t.options.accessibility===!0&&(t.initADA(),t.options.focusOnChange))){var o=i(t.$slides.get(t.currentSlide));o.attr("tabindex",0).focus()}},e.prototype.prev=e.prototype.slickPrev=function(){var i=this;i.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),r=document.createElement("img"),r.onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),l.options.adaptiveHeight===!0&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;return"boolean"==typeof i?(e=i,i=e===!0?0:o.slideCount-1):i=e===!0?--i:i,!(o.slideCount<1||i<0||i>o.slideCount-1)&&(o.unload(),t===!0?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,void o.reinit())},e.prototype.setCSS=function(i){var e,t,o=this,s={};o.options.rtl===!0&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,o.transformsEnabled===!1?o.$slideTrack.css(s):(s={},o.cssTransitions===!1?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;i.options.vertical===!1?i.options.centerMode===!0&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),i.options.centerMode===!0&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),i.options.vertical===!1&&i.options.variableWidth===!1?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):i.options.variableWidth===!0?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();i.options.variableWidth===!1&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,t.options.rtl===!0?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&i.options.adaptiveHeight===!0&&i.options.vertical===!1){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":"undefined"!=typeof arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),i.options.fade===!1?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=i.options.vertical===!0?"top":"left",
"top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||i.options.useCSS===!0&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&i.animType!==!1&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&i.animType!==!1},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),n.options.centerMode===!0){var r=n.options.slidesToShow%2===0?1:0;e=Math.floor(n.options.slidesToShow/2),n.options.infinite===!0&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=n.options.infinite===!0?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(s.options.fade===!0&&(s.options.centerMode=!1),s.options.infinite===!0&&s.options.fade===!1&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=s.options.centerMode===!0?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));return s||(s=0),t.slideCount<=t.options.slidesToShow?void t.slideHandler(s,!1,!0):void t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(a.animating===!0&&a.options.waitForAnimate===!0||a.options.fade===!0&&a.currentSlide===i))return e===!1&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,a.options.infinite===!1&&a.options.centerMode===!1&&(i<0||i>a.getDotCount()*a.options.slidesToScroll)?void(a.options.fade===!1&&(o=a.currentSlide,t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o))):a.options.infinite===!1&&a.options.centerMode===!0&&(i<0||i>a.slideCount-a.options.slidesToScroll)?void(a.options.fade===!1&&(o=a.currentSlide,t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o))):(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!==0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!==0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=a.getNavTarget(),l=l.slick("getSlick"),l.slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide)),a.updateDots(),a.updateArrows(),a.options.fade===!0?(t!==!0?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight()):void(t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)))},e.prototype.startLoad=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),i.options.dots===!0&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),o=Math.round(180*t/Math.PI),o<0&&(o=360-Math.abs(o)),o<=45&&o>=0?s.options.rtl===!1?"left":"right":o<=360&&o>=315?s.options.rtl===!1?"left":"right":o>=135&&o<=225?s.options.rtl===!1?"right":"left":s.options.verticalSwiping===!0?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(o.touchObject.edgeHit===!0&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(e.options.swipe===!1||"ontouchend"in document&&e.options.swipe===!1||e.options.draggable===!1&&i.type.indexOf("mouse")!==-1))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,e.options.verticalSwiping===!0&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(l.options.verticalSwiping===!0&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(l.options.rtl===!1?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),l.options.verticalSwiping===!0&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,l.options.infinite===!1&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),l.options.vertical===!1?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,l.options.verticalSwiping===!0&&(l.swipeLeft=e+o*s),l.options.fade!==!0&&l.options.touchMove!==!1&&(l.animating===!0?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;return t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow?(t.touchObject={},!1):(void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,void(t.dragging=!0))},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i,e=this;i=Math.floor(e.options.slidesToShow/2),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&!e.options.infinite&&(e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===e.currentSlide?(e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-e.options.slidesToShow&&e.options.centerMode===!1?(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-1&&e.options.centerMode===!0&&(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||"undefined"==typeof s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),"undefined"!=typeof t)return t;return o}});
  
  
/*
 Sticky-kit v1.1.1 | WTFPL | Leaf Corcoran 2014 | http://leafo.net
*/
(function(){var k,e;k=this.jQuery||window.jQuery;e=k(window);k.fn.stick_in_parent=function(d){var v,y,n,p,h,C,s,G,q,H;null==d&&(d={});s=d.sticky_class;y=d.inner_scrolling;C=d.recalc_every;h=d.parent;p=d.offset_top;n=d.spacer;v=d.bottoming;null==p&&(p=0);null==h&&(h=void 0);null==y&&(y=!0);null==s&&(s="is_stuck");null==v&&(v=!0);G=function(a,d,q,z,D,t,r,E){var u,F,m,A,c,f,B,w,x,g,b;if(!a.data("sticky_kit")){a.data("sticky_kit",!0);f=a.parent();null!=h&&(f=f.closest(h));if(!f.length)throw"failed to find stick parent";
u=m=!1;(g=null!=n?n&&a.closest(n):k("<div />"))&&g.css("position",a.css("position"));B=function(){var c,e,l;if(!E&&(c=parseInt(f.css("border-top-width"),10),e=parseInt(f.css("padding-top"),10),d=parseInt(f.css("padding-bottom"),10),q=f.offset().top+c+e,z=f.height(),m&&(u=m=!1,null==n&&(a.insertAfter(g),g.detach()),a.css({position:"",top:"",width:"",bottom:""}).removeClass(s),l=!0),D=a.offset().top-parseInt(a.css("margin-top"),10)-p,t=a.outerHeight(!0),r=a.css("float"),g&&g.css({width:a.outerWidth(!0),
height:t,display:a.css("display"),"vertical-align":a.css("vertical-align"),"float":r}),l))return b()};B();if(t!==z)return A=void 0,c=p,x=C,b=function(){var b,k,l,h;if(!E&&(null!=x&&(--x,0>=x&&(x=C,B())),l=e.scrollTop(),null!=A&&(k=l-A),A=l,m?(v&&(h=l+t+c>z+q,u&&!h&&(u=!1,a.css({position:"fixed",bottom:"",top:c}).trigger("sticky_kit:unbottom"))),l<D&&(m=!1,c=p,null==n&&("left"!==r&&"right"!==r||a.insertAfter(g),g.detach()),b={position:"",width:"",top:""},a.css(b).removeClass(s).trigger("sticky_kit:unstick")),
y&&(b=e.height(),t+p>b&&!u&&(c-=k,c=Math.max(b-t,c),c=Math.min(p,c),m&&a.css({top:c+"px"})))):l>D&&(m=!0,b={position:"fixed",top:c},b.width="border-box"===a.css("box-sizing")?a.outerWidth()+"px":a.width()+"px",a.css(b).addClass(s),null==n&&(a.after(g),"left"!==r&&"right"!==r||g.append(a)),a.trigger("sticky_kit:stick")),m&&v&&(null==h&&(h=l+t+c>z+q),!u&&h)))return u=!0,"static"===f.css("position")&&f.css({position:"relative"}),a.css({position:"absolute",bottom:d,top:"auto"}).trigger("sticky_kit:bottom")},
w=function(){B();return b()},F=function(){E=!0;e.off("touchmove",b);e.off("scroll",b);e.off("resize",w);k(document.body).off("sticky_kit:recalc",w);a.off("sticky_kit:detach",F);a.removeData("sticky_kit");a.css({position:"",bottom:"",top:"",width:""});f.position("position","");if(m)return null==n&&("left"!==r&&"right"!==r||a.insertAfter(g),g.remove()),a.removeClass(s)},e.on("touchmove",b),e.on("scroll",b),e.on("resize",w),k(document.body).on("sticky_kit:recalc",w),a.on("sticky_kit:detach",F),setTimeout(b,
0)}};q=0;for(H=this.length;q<H;q++)d=this[q],G(k(d));return this}}).call(this);